import setCurrentPage from "src/Utils/setCurrentPage";
import store from "src/Reducers/store";
import { useSelector } from "react-redux";

import "./index.sass";
import { Button, ButtonGroups } from "@nocios/presentation-kit";
import React, { useEffect } from "react";

interface CustomProps {
  pageId: number;
  children: React.ReactNode;
  showBack?: boolean;
  showNext?: boolean;
  backVisible?: boolean;
  nextVisible?: boolean;
  extraComponent?: React.ReactNode;
}

const Custom = ({
  pageId,
  children,
  showBack = true,
  showNext = true,
  backVisible = true,
  nextVisible = true,
  extraComponent = <></>,
}: CustomProps) => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  const [firstRender, setFirstRender] = React.useState(true);

  const btns = [
    {
      label: "Back",
      type: "back",
      startIcon: { icon: "arrow-right", color: "#fff" },
      onClick: () => (backVisible ? setCurrentPage(currentPage - 1) : null),
    },
    {
      label: "Continue",
      type: "next",
      endIcon: { icon: "arrow-left" },
      onClick: () => (nextVisible ? setCurrentPage(currentPage + 1) : null),
    },
  ];

  useEffect(() => {
    if (firstRender)
      setTimeout(() => {
        setFirstRender(false);
      }, 1100);
  }, [firstRender]);

  return (
    <>
      {pageId === currentPage && (
        <div className="custom-center-content">
          <div className="custom-center-content-body">{children}</div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <ButtonGroups>
              {showBack && !firstRender && <Button {...btns[0]} style={{ transition: "opacity .8s", opacity: backVisible ? 1 : 0 }} />}
              {showNext && !firstRender && <Button {...btns[1]} style={{ transition: "opacity .8s", opacity: nextVisible ? 1 : 0 }} />}
            </ButtonGroups>
            {extraComponent}
          </div>
        </div>
      )}
    </>
  );
};

export default Custom;
